import { RevEmptyState, RevPersonaCard, RevSpinner } from "@revmatics/catalyst";
import { StepPersonaSelectProps } from "../CreateBriefTypes.ts";

export const StepPersonaSelect: React.FC<StepPersonaSelectProps> = ({
  personas,
  selectedPersonaId,
  onSelectPersona,
  isLoading,
  error,
}) => {
  if (isLoading) {
    return <RevSpinner size="large" centered />;
  }

  if (personas.length === 0) {
    return (
      <RevEmptyState
        title="No Personas Available"
        text="Please create personas first to proceed."
      />
    );
  }

  return (
    <div>
      <p className="typography-body-sm mb-2">Select Persona</p>
      <div className="px-2 border-monochrome-200 bg-monochrome-50 border rounded-lg max-h-[65dvh] lg:h-[200px] overflow-y-auto scroll-vertical">
        {personas.map((persona) => {
          const isSelected = selectedPersonaId === persona.id;
          return (
            <RevPersonaCard
              key={persona.id}
              persona={persona}
              isButtonVariant
              className="max-h-[80px] mt-3"
              selected={isSelected}
              onClick={() => onSelectPersona(persona.id)}
            />
          );
        })}
      </div>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
};
